module.exports = __webpack_public_path__ + "media/img/pages/companies/hslu-4adae01d08bfa0b304e4cf79030ac3c4.png";